/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const Dynamics365Svg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.1em"
    height="1.1em"
    fill="none"
    viewBox="0 0 96 96"
  >
    <g clipPath="url(#clip0)">
      <defs>
        <filter id="filter0_f">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            result="effect1_foregroundBlur"
            stdDeviation="0.4"
          ></feGaussianBlur>
        </filter>
        <filter id="filter1_f">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            result="effect1_foregroundBlur"
            stdDeviation="4"
          ></feGaussianBlur>
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="38.045"
          x2="56.658"
          y1="-1"
          y2="47.723"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0B53CE"></stop>
          <stop offset="1" stopColor="#7252AA"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="64.138"
          x2="64.138"
          y1="93.492"
          y2="35.415"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2266E3"></stop>
          <stop offset="1" stopColor="#AE7FE2"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="82"
          x2="62.076"
          y1="56.786"
          y2="56.786"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94B9FF"></stop>
          <stop offset="0.288" stopColor="#94B9FF" stopOpacity="0.524"></stop>
          <stop offset="1" stopColor="#538FFF" stopOpacity="0"></stop>
        </linearGradient>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0H96V96H0z"></path>
        </clipPath>
      </defs>
      <mask
        id="mask0"
        width="70"
        height="96"
        x="12"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          d="M82 31.047a10 10 0 00-6.637-9.417L17.345.909C14.74-.021 12 1.909 12 4.676v31.505a4 4 0 002.655 3.767l26 9.286c2.605.93 5.345-1.001 5.345-3.767v-18.09a2 2 0 012.704-1.872l6.818 2.566A10 10 0 0162 37.43v7.878L32.627 56.04A4 4 0 0030 59.797V91.28c0 2.778 2.763 4.71 5.373 3.757L75.432 80.4A10 10 0 0082 71.007v-39.96z"
        ></path>
      </mask>
      <g mask="url(#mask0)">
        <path
          fill="url(#paint0_linear)"
          d="M12-1l70 25v34.325c0 2.765-2.74 4.697-5.345 3.767L62 56.859V37.424a10 10 0 00-6.483-9.361l-6.814-2.56A2 2 0 0046 27.375v23.768L12 39V-1z"
        ></path>
        <g filter="url(#filter0_f)">
          <path
            fill="#000"
            fillOpacity="0.24"
            d="M82 31.4c0 4.2-2.624 7.959-6.568 9.4L30 57.4v40l52-19v-47z"
          ></path>
        </g>
        <g filter="url(#filter1_f)">
          <path
            fill="#000"
            fillOpacity="0.32"
            d="M82 33c0 4.2-2.624 7.959-6.568 9.4L30 59v40l52-19V33z"
          ></path>
        </g>
        <path
          fill="url(#paint1_linear)"
          d="M82 31c0 4.2-2.624 7.959-6.568 9.4L30 57v40l52-19V31z"
        ></path>
        <path
          fill="url(#paint2_linear)"
          d="M82 31c0 4.2-2.624 7.959-6.568 9.4L30 57v40l52-19V31z"
          opacity="0.5"
        ></path>
        <path
          fill="#B0ADFF"
          d="M62.001 45.32l-16.009 5.857v23.458a2 2 0 002.705 1.872l6.827-2.57a10 10 0 006.477-9.36V45.32z"
          opacity="0.5"
        ></path>
      </g>
    </g>
  </svg>
);

export const Dynamics365Icon = (props) => (
  <Icon component={Dynamics365Svg} {...props} />
);
